import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IfCrAwareDirective } from './if-cr-aware/if-cr-aware.directive';
import {
  FlipperDisabledDirective,
  FlipperEnabledDirective,
} from './flipper-switch/flipper-switch.directive';
import {
  IfAgencyHasFeatureDirective,
  IfAgencyLacksFeatureDirective,
} from './feature-switch/feature-switch.directive';
import { InPendoSegmentDirective } from './pendo-segment/pendo-segment.directive';

@NgModule({
  declarations: [
    IfCrAwareDirective,
    FlipperEnabledDirective,
    FlipperDisabledDirective,
    IfAgencyHasFeatureDirective,
    IfAgencyLacksFeatureDirective,
    InPendoSegmentDirective,
  ],
  exports: [
    IfCrAwareDirective,
    FlipperEnabledDirective,
    FlipperDisabledDirective,
    IfAgencyHasFeatureDirective,
    IfAgencyLacksFeatureDirective,
    InPendoSegmentDirective,
  ],
  imports: [CommonModule],
})
export class ContextDirectivesModule {}
